import React from 'react';

import {CardTitle} from '~src/spacesPlatform/components/card/CardTitle';

import { L10n } from '../../../commonInfra/L10n/L10n';
import { IExplorableItemTypeInfo } from '../../models/resourceInfoParts';
import { CardViewStyles } from './CardViewStyles';

export interface GenericCardProps {
  content: IExplorableItemTypeInfo;
}

export function GenericCard(props: GenericCardProps): React.ReactElement<GenericCardProps> {
  return (
    <div className={CardViewStyles.Card}>
      <div className={CardViewStyles.Thumbnail}>
        <h3>
          <span>{L10n.elideIfLong(props.content.id)}</span>
          <span>{props.content.contentType}</span>
        </h3>
      </div>
      <div className={CardViewStyles.ActionRow}>
        <CardTitle name={L10n.elideIfLong(props.content.name)} />
      </div>
    </div>
  );
}
